export default __webpack_public_path__ + "static/media/Orchha.a3b08ae8.jpg";